import { Component, OnInit } from '@angular/core';
import { IssuerAPIService } from '../services/issuer-api.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare function responsiveVoiceSpeak_PasswordRules(title, innerText): any;
declare function VoiceOnKeyPress(value, key, eventId): any;
declare function ShowErrorSnackbar(): any;
declare function ShowSnackbar_ForgotPasswordSuccess(): any;

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {

  tabIndex: number;
  commontabIndex: number;
  loading: boolean = true;
  model: any = {};
  IsNotSuccess = false;
  IsSuccess = false;
  password_resetCode: string;
  passwordRules_list: any;
  messagelist: any;
  errorMessage: string;
  constructor(private router: ActivatedRoute, private IssuerAPI: IssuerAPIService) {
    this.tabIndex = 21;
    this.commontabIndex = 22;
  }

  ngOnInit() {
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }

    responsiveVoiceSpeak("", "This is reset password page. Use tab to go to the next field.");
   
    this.password_resetCode = this.router.snapshot.queryParamMap.get('p');
    document.getElementById("overlay").style.display = "block";
    this.QueryPasswordRules();
    //=========Caption Hide Show=============//
  }

  // to get password rules list from APi
  QueryPasswordRules(): void {

    this.IssuerAPI.GetPasswordRules().subscribe(data => {

      this.passwordRules_list = data;
      this.commontabIndex = this.tabIndex + data["length"];
      document.getElementById("overlay").style.display = "none";
    });

  }

  //to reset form  
  ResetForm(): void {
    this.model.password = '';
    this.model.confirmPassword = '';
  }
  Onkeyup(event: any) {
    this.IsNotSuccess = false;
    this.IsSuccess = false;

    if (event.keyCode == 9) {
      if (event.target.title == "passwordRules") {
        responsiveVoiceSpeak_PasswordRules("", event.target.innerText);
      }

    }
    if (event.target.id == "lblrule" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblrule").innerText, "lblrule", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("onDemandWeb").focus();
      return;
    }

    if (event.target.id == "lblResetpassword" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblResetpassword").innerText, "lblResetpassword", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("onDemandWeb").focus();
      return;
    }

    if (event.target.id == "btnReset" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Reset button. Press enter to save your new password or use tab to go to the next field.");
    }

    if (event.target.id == "btnLogin" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Login. Select this link to go to the Login page. Use Enter key to select or tab to go to the next footer.");
    }

    if (event.target.id == "txtresetpassword1" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Password. Please enter your new password. This is a mandatory field. Use tab to go to the next field.");
    }

    if (event.target.id == "txtresetpassword2" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Confirm password. Please confirm your new password. This is a mandatory field. Use tab to go to the next field.");
    }

    if (event.target.id == "btnReset" && event.keyCode == 13) {
      this.onSubmit();
    }

    else if (event.keyCode == 27) {
      //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //}
    }


  }
  onkeypress(event: any) {
    debugger
    if ((event.target.id == "txtresetpassword1" || event.target.id == "txtresetpassword2")) {

      var reset1 = $("#txtresetpassword1").val().trim();
      var reset2 = $("#txtresetpassword2").val().trim();

      if (event.target.id == "txtresetpassword1" && event.keyCode == 9) {
        responsiveVoiceSpeak("", "Password. Please enter your new password. This is a mandatory field. Use tab to go to the next field.");
      }

      if (event.target.id == "txtresetpassword2" && event.keyCode == 9) {
        responsiveVoiceSpeak("", "Confirm password. Please confirm your new password. This is a mandatory field. Use tab to go to the next field.");
      }

      if ((event.target.id == "txtresetpassword1" || event.target.id == "txtresetpassword2") && (event.keyCode > 46)) {
        VoiceOnKeyPress(event.target.value, event.key, event.target.id);
      }

      if (reset1 != "" && reset2 != "") {

        this.loading = false;
      }
      else {
        this.loading = true;
      }

      return;

    }

  }

  // submit reset form

  onSubmit() {
    debugger;
    this.IssuerAPI.ResetPassword_Eng(this.model.password, this.model.confirmPassword, this.password_resetCode).
      subscribe(data => {
        debugger
        var response = data;
        if (response.success) {
          this.ResetForm();

          //this.IsNotSuccess = false;
          //this.IsSuccess = true;
          $("#btnLogin").focus();
          responsiveVoiceSpeak("", response.message + ". Use enter to go to the login page or use tab to  go to the footer.");

          this.errorMessage = response.message;

          ShowSnackbar_ForgotPasswordSuccess();

          //var x = document.getElementById("snackbar");
          //x.className = "show";
          //setTimeout(function () { x.className = x.className.replace("show", ""); }, 4000);

        }
        else {
          this.messagelist = response.errorMessages;
          ShowErrorSnackbar();
          //this.IsSuccess = false;
          //this.IsNotSuccess = true;
          //this.messagelist = response.errorMessages;
          //var x = document.getElementById("errorsnackbar");
          //x.className = "show";
          //setTimeout(function () { x.className = x.className.replace("show", ""); }, 4000);
          $("#txtresetpassword1").val('');
          $("#txtresetpassword2").val('');
          $("#txtresetpassword1").focus();
          responsiveVoiceSpeak("", (this.messagelist ? this.messagelist.join("\n") : "") + "\nPlease enter a new password again..");

          // responsiveVoiceSpeak("", "Please enter a new password again.");

        }

      });

    return;

  }

  //onSubmit() {
  //  debugger;
  //  this.IssuerAPI.ResetPassword_Eng(this.model.password, this.model.confirmPassword, this.password_resetCode).
  //    subscribe(data => {

  //      var response = data;
  //      if (response.success) {
  //        this.ResetForm();
         
  //        this.IsNotSuccess = false;
  //        this.IsSuccess = true;
  //        $("#btnLogin").focus();
  //        responsiveVoiceSpeak("", response.message + ". Use enter to go to the login page or use tab to  go to the footer.");

  //        this.errorMessage = response.message;

  //        var x = document.getElementById("snackbar");
  //        x.className = "show";
  //        setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);

  //      }
  //      else {
  //        this.IsSuccess = false;
  //        this.IsNotSuccess = true;
  //        this.messagelist = response.errorMessages;
  //        var x = document.getElementById("errorsnackbar");
  //        x.className = "show";
  //        setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
  //        $("#txtresetpassword1").val('');
  //        $("#txtresetpassword2").val('');
  //        $("#txtresetpassword1").focus();
  //        responsiveVoiceSpeak("", "Please enter a new password again.");

  //      }

  //    });

  //  return;

  //}
}
